export class MonthStatus {
  static get InProgress () {
    return 1
  }
  static get Stop () {
    return 2
  }
  static get Terminate () {
    return 4
  }

  static MonthStatusName (monthStatus) {
    let tmpType = parseInt(monthStatus)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '進行中'
        break
      case 2:
        name = '合約暫停'
        break
      case 4:
        name = '合約終止'
        break
    }
    return name
  }
}
